import {
  MenuAction,
  useSnackbarContext,
  writeToClipboard,
} from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";

export const usePublicProfileActions = (
  enabled: boolean,
  setEnabled: (enabled: boolean) => Promise<{ data?: object; error?: object }>,
  url: string
): MenuAction[][] => {
  const { t } = useTranslation("translation", {
    keyPrefix: "profile.public_profile",
  });
  const { addSnackbar } = useSnackbarContext();

  if (enabled) {
    return [
      [
        {
          id: "disable-public-profile",
          testId: "disable-public-profile",
          label: t("card.actions.disable.label"),
          iconLeft: "toggle-off-outlined",
          onClick: () => {
            setEnabled(false)
              .then(() => {
                addSnackbar(t("card.actions.disable.success_message"));
              })
              .catch(() => {
                addSnackbar(t("card.actions.disable.error_message"));
              });
          },
        },
      ],
      [
        {
          id: "view-public-profile",
          testId: "view-public-profile",
          label: t("card.actions.view_public_profile.label"),
          iconLeft: "visibility",
          iconRight: "open-small",
          iconRightVariant: "neutralLight",
          onClick: () => window.open(url),
        },
        {
          id: "copy-public-profile-link",
          testId: "copy-public-profile-link",
          label: t("card.actions.copy_link.label"),
          iconLeft: "link",
          onClick: () => {
            writeToClipboard(url)
              .then(() => {
                addSnackbar(t("card.actions.copy_link.success_message"));
              })
              .catch((error: unknown) => {
                addSnackbar(t("card.actions.copy_link.error_message"), {
                  type: "error",
                });
                console.error(error);
              });
          },
        },
      ],
    ];
  }

  return [
    [
      {
        id: "enable-public-profile",
        testId: "enable-public-profile",
        label: t("card.actions.enable.label"),
        iconLeft: "toggle-on-outlined",
        onClick: () => {
          setEnabled(true)
            .then(() => {
              addSnackbar(t("card.actions.enable.success_message"));
            })
            .catch(() => {
              addSnackbar(t("card.actions.enable.error_message"));
            });
        },
      },
    ],
  ];
};
